// extracted by mini-css-extract-plugin
export default {"root":"iEJlw","stats":"_3PZlp","boosted":"_1TszT","boosted-text":"_3UF9i","boostedText":"_3UF9i"};